module.exports = __webpack_public_path__ + "static/img/ramka_czerwona.953250b7.png";